<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center" style="background: rgba(0,0,0,0.55)">
    <div class="w-11/12 sm:w-7/12 md:w-5/12 p-8 bg-white rounded shadow-xl">
      <div class="flex justify-center mb-4">
        <img src="/img/TardiniLogo.svg" class="w-4/12" />
      </div>

      <!-- STEP 1: email + codice -->
      <div v-if="step === 'email'">
        <h2 class="text-lg font-bold text-center text-gray-800 mb-2">Imposta email di recupero</h2>
        <p class="text-sm text-gray-600 mb-4 text-center">
          Per proseguire verifica un'email: ti servira' per recuperare la password.
        </p>
        <div v-if="!codeSent">
          <label class="block text-sm text-gray-700">Email</label>
          <input type="email" v-model="mail" placeholder="email"
                 class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" />
          <button @click="sendCode" :disabled="busy"
                  class="mt-4 w-full px-4 py-2 text-white bg-button-red rounded focus:outline-none">Invia codice</button>
        </div>
        <div v-else>
          <p class="text-sm text-gray-600 mb-2">Codice inviato a <b>{{ mail }}</b> (controlla anche lo spam):</p>
          <label class="block text-sm text-gray-700">Codice</label>
          <input type="text" v-model="code" placeholder="codice"
                 class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" />
          <button @click="verifyCode" :disabled="busy"
                  class="mt-4 w-full px-4 py-2 text-white bg-button-red rounded focus:outline-none">Verifica</button>
          <button @click="codeSent=false" class="mt-2 w-full text-sm text-gray-600 underline focus:outline-none">Cambia email</button>
        </div>
      </div>

      <!-- STEP 2: nuova password -->
      <div v-else>
        <h2 class="text-lg font-bold text-center text-gray-800 mb-2">Imposta una nuova password</h2>
        <p class="text-xs text-gray-600 mb-4 text-center">
          Min 8 caratteri, con minuscola, maiuscola, numero e simbolo. Diversa da quella attuale.
        </p>
        <label class="block text-sm text-gray-700">Password attuale</label>
        <input type="password" v-model="currentPassword" class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" />
        <label class="block text-sm text-gray-700 mt-3">Nuova password</label>
        <input type="password" v-model="newPassword" class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" />
        <label class="block text-sm text-gray-700 mt-3">Ripeti nuova password</label>
        <input type="password" v-model="repeatNewPassword" class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" />
        <button @click="changePassword" :disabled="busy"
                class="mt-4 w-full px-4 py-2 text-white bg-button-red rounded focus:outline-none">Salva password</button>
      </div>

      <p v-if="error" class="mt-3 text-sm text-red-700 text-center">{{ error }}</p>
      <p v-if="success" class="mt-3 text-sm text-green-700 text-center">{{ success }}</p>

      <button @click="logout" class="mt-4 w-full text-sm text-gray-500 underline focus:outline-none">Esci</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    const u = this.$store.state.user;
    return {
      step: (u && u.mail_verified) ? 'password' : 'email',
      mail: (u && u.mail) ? u.mail : '',
      code: '',
      codeSent: false,
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: '',
      busy: false,
      error: '',
      success: ''
    }
  },
  methods: {
    async sendCode() {
      this.error=''; this.success=''; this.busy=true;
      try {
        await this.axios.post('/auth/send-mail-code', { mail: this.mail });
        this.codeSent = true;
        this.success = 'Codice inviato, controlla la posta.';
      } catch(e) { this.error = this.msg(e); }
      this.busy=false;
    },
    async verifyCode() {
      this.error=''; this.success=''; this.busy=true;
      try {
        await this.axios.post('/auth/verify-mail-code', { code: this.code });
        this.step = 'password';
        this.success = 'Email verificata. Ora imposta la password.';
      } catch(e) { this.error = this.msg(e); }
      this.busy=false;
    },
    async changePassword() {
      this.error=''; this.success=''; this.busy=true;
      try {
        await this.axios.post('/auth/changepassword', {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
          repeatNewPassword: this.repeatNewPassword
        });
        this.success = 'Password aggiornata!';
        this.$store.commit('show_change_password', false);
        setTimeout(() => window.location.reload(), 800);
      } catch(e) { this.error = this.msg(e); }
      this.busy=false;
    },
    async logout() {
      try { await this.axios.post('/auth/logout'); } catch(e) {}
      this.$store.commit('logout');
      this.$router.push({ name: 'login' });
    },
    msg(e) {
      return (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Errore, riprova';
    }
  }
}
</script>
